import React from "react";

const PreparationTimeToken = ({ label, language = "english" }) => {
  if (!label) return null;
  const accessibleLabel =
    language === "arabic" ? `وقت التحضير ${label}` : `Preparation time ${label}`;
  return (
    <span
      aria-label={accessibleLabel}
      style={{
        alignItems: "center",
        background: "rgba(255,255,255,0.9)",
        border: "1px solid rgba(0,0,0,0.12)",
        borderRadius: 10,
        color: "#444",
        display: "inline-flex",
        fontSize: 11,
        fontWeight: 600,
        gap: 4,
        lineHeight: "18px",
        padding: "0 7px",
      }}
    >
      <span aria-hidden="true">◷</span>
      {label}
    </span>
  );
};

export default PreparationTimeToken;
